<template lang="pug">
  .welcome
    FixedWidthTweakUpper
      SectionBlock(no-padding=true)
        WelcomeCustomer
        StylingProductsHeroBanner

      SectionBlock(v-if="recentInvoices && recentInvoices.length" no-padding=true)
        WelcomeRecentInvoices

      SectionBlock#color-survey(v-if="showColorSatisfaction")
        ColorSatisfaction(:invoice-id="colorSatisfactionInvoice.id" :product="colorSatisfactionInvoice.product")

      SectionBlock#next-shipment.welcome-next-shipment-block(v-if="showNextSubShipment" no-padding=true)
        WelcomeNextShipment

      SectionBlock#customize-your-kit(v-if="cdata.activeSubscriber && showNextSubShipment && boostRecommendations.length" no-padding=true)
        .scroll-to
        CustomizeYourKit

      SectionBlock(v-if="showSubAndSave" no-padding=true)
        WelcomeSubscribeAndSave(:product-id="subscribeAndSaveProduct.product_id")

      .refill-xsell-block(v-if="showXsell")
        SectionBlock
          ReturnCustomerXsell

      SectionBlock.color-bar-wrap
        .image-wrap.xs-f-small.md-f-small.lg-f-large.max-at-tweak
          img-box(media-id="6250")
        .xs-12.md-7
        .cta-wrap.xs-12.md-5.text-center
          SectionTitle.color-bar-title(text="Color Bar")
          p.xs-f-small.max-at-tweak Fast + Fabulous hair color with ingredients you can feel good about
          a.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(href="/colorbar/locations") Book Now
          a.block.xs-f-small.max-at-tweak(href="/colorbar") Learn more

      ExpertiseIncluded

      party.birthday-confetti-vue(:birthday='true' url-param='bday' limit-cookie='bday')
        .absolute-wrap
          .v-center.full-width.text-center
            p.birthday-text.semi-bold.didot.xs-f-xgrande.md-f-xxxgrande.lg-f-xxgrande.max-at-tweak
              span.upper Happy Birthday
              br
              span.script.lower.semi-bold.color-purple.xs-f-xgrande.md-f-xxxgrande.lg-f-xxgrande.max-at-tweak(v-if="cdata.firstName") {{cdata.firstName}}
              span.script.lower.semi-bold.color-purple.xs-f-xgrande.md-f-xxxgrande.lg-f-xxgrande.max-at-tweak(v-if="!cdata.firstName") Beautiful
                span.normal.xs-f-grande.md-f-xxgrande.lg-f-xgrande.max-at-tweak &trade;

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import ImgBox from '../../../imgBox';
  import party from '../../../party';
  import SectionBlock from '../../SectionBlock';
  import SectionTitle from '../../../SectionTitle';
  import WelcomeCustomer from "./WelcomeCustomer";
  import StylingProductsHeroBanner from "./StylingProductsHeroBanner";
  import ExpertiseIncluded from '../../../ExpertiseIncluded';
  import FixedWidthTweakUpper from "../../../FixedWidthTweakUpper";
  import ReturnCustomerXsell from "./ReturnCustomerXsell/ReturnCustomerXsell";

  export default {
    name: "ReturnCustomer",

    data() {
      return {
        isMounted: false,
        confirmRefillAddonModalShown: false
      }
    },

    components: {
      ReturnCustomerXsell,
      FixedWidthTweakUpper,
      SectionBlock,
      SectionTitle,
      WelcomeCustomer,
      StylingProductsHeroBanner,
      ExpertiseIncluded,
      ImgBox,
      party,
      'ColorSatisfaction': () => import('./ColorSatisfaction'),
      'WelcomeSubscribeAndSave': () => import('./WelcomeSubscribeAndSave'),
      'WelcomeNextShipment': () => import('./WelcomeNextShipment'),
      'CustomizeYourKit': () => import('./CustomizeYourKit'),
      'WelcomeRecentInvoices': () => import('./WelcomeRecentInvoices'),
    },

    computed: {
      ...mapState('customer', [
        'cdata',
        'recentInvoices'
      ]),

      ...mapState('refillCart', [
        'refillCart'
      ]),

      ...mapState('xsell', [
        'boostRecommendations',
        'membershipXsellProducts'
      ]),

      ...mapGetters('subscriptions', [
        'nextSubShipment',
        'activeSubscriptionIds'
      ]),

      ...mapGetters('customer', [
        'isColorSubscriber',
        'subscribeAndSaveProduct',
        'colorSatisfactionInvoice'
      ]),

      ...mapGetters('refillCart', [
        'productIdInRefillCart'
      ]),

      showXsell() {
        return Boolean(this.refillCart.nextShipment && this.xsellItemsNotInRefillCart.length);
      },

      xsellItemsNotInRefillCart() {
        return this.membershipXsellProducts.filter(refillItem => !this.productIdInRefillCart(refillItem.id))
      },

      showNextSubShipment() {
        return Boolean(this.nextSubShipment && this.nextSubShipment.length > 0);
      },

      showSubAndSave() {
        return !this.showNextSubShipment && this.subscribeAndSaveProduct;
      },

      showColorSatisfaction() {
        return Boolean(this.colorSatisfactionInvoice.id && this.colorSatisfactionInvoice.product && this.colorSatisfactionInvoice.product.id);
      }
    },

    methods: {
      ...mapActions('customer', ['getRecentInvoices']),
      ...mapActions('subscriptions', ['initSubscriptions']),
      ...mapActions('xsell', [
        'initBoostRecommendations',
        'initMembershipXsellProducts'
      ])
    },

    mounted() {
      this.isMounted = true;
      // modal handling
      if (this.$route.query.urlKey && this.$route.query.idx) {
        this.confirmRefillAddonModalShown = true;
        this.$store.dispatch('modal/showModal', { component: './Dashboard/Welcome/ReturnCustomer/ConfirmRefillAddonModal' }, { root: true });
      }

      if (this.$route.path == '/dashboard/welcome/recommendations') {
        this.$root.scrollTo('.refill-xsell-block', 600, 500);
      }

      this.initSubscriptions();
      this.initMembershipXsellProducts();
      this.getRecentInvoices();
      if (this.$route.path == '/dashboard/welcome/nextShipment') {
        window.setTimeout(this.$root.scrollTo, 700, '.welcome-next-shipment-block');
      }

      this.initBoostRecommendations();

      if (this.$route.hash) {
        setTimeout(() => {
          this.$root.scrollTo(this.$route.hash);
        }, 2000); //- long timeout is necessary so that all sections are loaded before scroll starts
      }
    }
  }
</script>

<style scoped lang="stylus">
  .welcome-next-shipment-block
    overflow visible !important

  #customize-your-kit
    .scroll-to
      position absolute
      pointer-events none
      top -1.5em
      left 0

  .color-bar-wrap
    position relative
    padding 0 !important

    .image-wrap
      position absolute
      top 0
      right 41.666%
      bottom 0
      left 0

    .cta-wrap
      padding 1.5em 5%
      padding-bottom 2.5em

      .mr-btn
        margin-top 2em
        margin-bottom 1.5em

    .birthday-confetti
      position fixed
      z-index 250
      top 0
      right 0
      bottom 0
      left 0
      width 100%
      height 100%
      background-color rgba(256, 256, 256, 0.95)
      display none

      .birthday-text
        line-height 1.4em

    @media mq-tablet-less
      .image-wrap
        position relative
        margin-top 4.5em
        right 0
        height 18em

      .cta-wrap
        position inherit

        .color-bar-title
          position absolute
          left 0
          right 0
          top 0.75em

    @media mq-mobile
      .cta-wrap
        padding 1.5em 10%
        padding-bottom 2em

    @media mq-tablet
      .cta-wrap
        padding 1.5em 20%
        padding-bottom 2em

</style>
